import axios from '@/modules/login/service/axios-login';

const criar = (transportador) => axios.post('/open/transportadoras', transportador);

export default {
  criar,
};
